import { Col, Row } from "antd";
import { CustomText, CustomTextArea } from "../../../../../components";

const CancelRequest = ({ formik }: any) => {
  return (
    <>
      <CustomText
        centered={true}
        strong={true}
        text='¿Desea anular la solicitud?'
      />
      <br />
      <Row>
        <Col xs={24}>
          <CustomTextArea
            label="Observaciones"
            name="reason"
            placeholder="Observaciones"
            value={formik.values.reason}
            error={formik.errors.reason}
            touched={formik.touched.reason}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
        </Col>
      </Row>
    </>
  );
};

export default CancelRequest;
